import "./logo.css"

export default function Logo() {
    return (
      <div>
          <img
            className="logoImage"
            src={"/images/logo.png"}
            alt="lightning bolt logo"
            />

      </div>
    )
  }
